import { useState } from "react";
import { BiErrorCircle } from "react-icons/bi";
import Loader from "../../components/Loader";
import "./styles.css";

import TiposSuggestions from "../../components/TiposSuggestions";
import useBooks from "../../utils/mocks/books/useBooks";
import useMusics from "../../utils/mocks/musics/useMusics";
import usePlaces from "../../utils/mocks/places/usePlaces";
import Layout from "../../components/Layout";

const Suggestions = (props) => {
  const { data: musicsResult, loading: loadingMusic, error: errMusic } = useMusics();
  const { data: booksResult, loading: loadingBooks, error: errBooks } = useBooks();
  const { data: placesResult, loading: loadingPlaces, error: errPlaces } = usePlaces();
  const loading = loadingMusic || loadingBooks || loadingPlaces;
  const hasError = errMusic || errBooks || errPlaces;

  return (
    <Layout
      title="Sugestões"
      titleColor="#6184FE"
      description="Sugestões culturais escolhidas para estimular o desenvolvimento dos pacientes de forma divertida."
      children={
        <div className="result-container">
          {loading ? (
            <Loader size={40} />
          ) : hasError ? (
            <div className="item-error">
              <BiErrorCircle /> Houve um erro ao processar sua solicitação.
            </div>
          ) : (
            <div className="result-container">
              <TiposSuggestions
                type={"Músicas"}
                list={musicsResult} 
                link={"/musicas"}
              />
              <TiposSuggestions
                type={"Locais"}
                list={placesResult}
                link={"/locais"}
              />
              <TiposSuggestions
                type={"Livros"}
                list={booksResult}
                link={"/livros"}
              />
            </div>
          )}
        </div>
      }
    />
  );
};

export default Suggestions;